/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-08-15 15:43:05
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-08-20 10:27:55
 * @FilePath: \mpc-2\features\mpc-common\src\features\Bidding\BiddingAgreeCheckbox\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { AgreeCheckBox, AgreeCheckBoxProps } from '#components'
import React, { forwardRef, ForwardedRef } from 'react'
import classNames from 'classnames/bind'
import styles from './index.less'

const cx = classNames.bind(styles)

export type BiddingAgreeCheckboxProps = {
  value: boolean
  onChange: (value: boolean) => void
} & AgreeCheckBoxProps

const BiddingAgreeCheckbox = forwardRef<HTMLDivElement, BiddingAgreeCheckboxProps>(
  ({ value, onChange, ...restProps }, ref: ForwardedRef<any>) => {
    return (
        <AgreeCheckBox
        checkboxText='接受邀约前请阅读并勾选同意'
        buttonText='《比选须知》'
        okButtonText='我已阅读并知悉上述内容，如违反上述要求，将根据标准承担相应后果与处罚'
        cancelButtonText=''
        modalTitle='比选须知'
        modalContent={
          <div>
            <div className={cx('content')}>
              <div className={cx('frame-1321315167')}>
                <div className={cx('text')}>请确认邀约供应商注意，比选方案以及讲标过程中：</div>
                <div className={cx('frame-1321315925')}>
                  <div className={cx('text-0004')}>一、不得包含任何可能透露/识别供应商的信息，包括但不限于：</div>
                  <div className={cx('frame-1321315926')}>
                    <div className={cx('text-0005')}>
                      <p>1.技术方案中露出供应商Logo/名称等信息；</p>
                      <p>2.讲标过程露出供应商名称，如：</p>
                    </div>
                  </div>
                  <div className={cx('frame-1321315927')}>
                    <ul className={cx('text-0005')}>
                      <li>线上会议名称未修改为供应商X，显示真实人名；</li>
                      <li>露出PPT文件名，但未体现具体供应商信息；</li>
                      <li>投屏露出桌面微信、POPO，泄露供应商信息等；</li>
                    </ul>
                  </div>
                  <div className={cx('frame-1321315928')}>
                    <div className={cx('text-0005')}>
                      <p>3.使用未脱敏的团队简历（如过往项目成员真实姓名+客户名称组合)；</p>
                      <p>4.其他可能导致透露/识别供应商的情况。</p>
                    </div>
                  </div>
                </div>
                <div className={cx('text-0001')}>
                  二、案例分享部分，不得包含本次需求方产品/IP的案例，如蛋仔派对需求的提案不得包含蛋仔派对/蛋仔滑滑等过往案例分享。
                </div>
                <div className={cx('text-0001')}>
                  三、预算分配仅需体现对应模块分配的预算，不得呈现具体的税服与折扣。折扣与税服仅需在报价单中呈现即可。
                </div>
                <div className={cx('text-0002')}>如违反上述规则，评审小组将根据相应的处罚标准进行扣分/取消评标资格。</div>
                <div className={cx('text-0003')}>
                  <p className={cx('el')}>
                    <span className={cx('el-0001')}>
                      以上规则最终解释权归网易所有，若有疑问请及时联系对应项目对接人；若操作过程中有发现违规操作，可向网易投诉，投诉渠道：{' '}
                    </span>
                    <a className={cx('el-0002')} href='https://jubao.163.com' target='_blank'>https://jubao.163.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
        value={value}
        onChange={onChange}
        modalWidth={800}
        {...restProps}
        ref={ref}
      />
    )
  }
)

BiddingAgreeCheckbox.displayName = 'BiddingAgreeCheckbox'

export default BiddingAgreeCheckbox
